<template>
  <div>
    <form class="profile__form">
      <div class="profile__form-group">
        <b-row>
          <b-col class="custom-form-control" md="12">
            <div class="schedule-settings-card">
              <h4>Opção 1</h4>
              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Data:</label>
                  <input
                    class="form-control input-width"
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[0].from_date.$error
                    }"
                    type="tel"
                    v-mask="'##/##/####'"
                    v-model="$v.slot_config.$each[0].from_date.$model"
                  />
                  <div v-if="$v.slot_config.$each[0].from_date.$error">
                    <p
                      class="error"
                      v-if="!$v.slot_config.$each[0].from_date.required"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>

                <b-col class="custom-form-control" md="8">
                  <form class="custom-select-form">
                    <div class="custom-select-wrap">
                      <h6 class="custom-select-title">Minutos:</h6>
                      <select
                        v-model="slot_config[0].duration"
                        class="custom-select"
                      >
                        <option
                          v-for="duration in durations"
                          :key="duration"
                          :selected="duration === slot_config[0].duration"
                          :value="duration"
                        >
                          {{ duration }}
                        </option>
                      </select>
                    </div>
                    <div class="custom-select-text">
                      <p>
                        Serão {{ slot_config[0].duration }} minutos para cada
                        paciente.
                      </p>
                    </div>
                  </form>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Horário:</label>
                  <input
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[0].work_days.$each[0].times
                          .$each[0].start_time.$error
                    }"
                    v-model="
                      $v.slot_config.$each[0].work_days.$each[0].times.$each[0]
                        .start_time.$model
                    "
                    class="form-control input-width"
                    type="time"
                    min="00:00"
                    max="23:59"
                  />
                  <div
                    v-if="
                      $v.slot_config.$each[0].work_days.$each[0].times.$each[0]
                        .start_time.$error
                    "
                  >
                    <p
                      class="error"
                      v-if="
                        !$v.slot_config.$each[0].work_days.$each[0].times
                          .$each[0].start_time.required
                      "
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="profile__form-group">
        <b-row>
          <b-col class="custom-form-control" md="12">
            <div class="schedule-settings-card">
              <h4>Opção 2</h4>
              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Data:</label>
                  <input
                    class="form-control input-width"
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[1].from_date.$error
                    }"
                    type="tel"
                    v-mask="'##/##/####'"
                    v-model="$v.slot_config.$each[1].from_date.$model"
                  />

                  <div v-if="$v.slot_config.$each[1].from_date.$error">
                    <p
                      class="error"
                      v-if="!$v.slot_config.$each[1].from_date.required"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>
                <b-col class="custom-form-control" md="8">
                  <form class="custom-select-form">
                    <div class="custom-select-wrap">
                      <h6 class="custom-select-title">Minutos:</h6>
                      <select
                        v-model="slot_config[1].duration"
                        class="custom-select"
                      >
                        <option
                          v-for="duration in durations"
                          :key="duration"
                          :selected="duration === slot_config[1].duration"
                          :value="duration"
                        >
                          {{ duration }}
                        </option>
                      </select>
                    </div>
                    <div class="custom-select-text">
                      <p>
                        Serão {{ slot_config[1].duration }} minutos para cada
                        paciente.
                      </p>
                    </div>
                  </form>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Horário:</label>
                  <input
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[1].work_days.$each[0].times
                          .$each[0].start_time.$error
                    }"
                    v-model="
                      $v.slot_config.$each[1].work_days.$each[0].times.$each[0]
                        .start_time.$model
                    "
                    class="form-control input-width"
                    type="time"
                    min="00:00"
                    max="23:59"
                  />
                  <div
                    v-if="
                      $v.slot_config.$each[1].work_days.$each[0].times.$each[0]
                        .start_time.$error
                    "
                  >
                    <p
                      class="error"
                      v-if="
                        !$v.slot_config.$each[1].work_days.$each[0].times
                          .$each[0].start_time.required
                      "
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="profile__form-group">
        <b-row>
          <b-col class="custom-form-control" md="12">
            <div class="schedule-settings-card">
              <h4>Opção 3</h4>
              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Data:</label>
                  <input
                    class="form-control input-width"
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[2].from_date.$error
                    }"
                    type="tel"
                    v-mask="'##/##/####'"
                    v-model="$v.slot_config.$each[2].from_date.$model"
                  />

                  <div v-if="$v.slot_config.$each[2].from_date.$error">
                    <p
                      class="error"
                      v-if="!$v.slot_config.$each[2].from_date.required"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>

                <b-col class="custom-form-control" md="8">
                  <form class="custom-select-form">
                    <div class="custom-select-wrap">
                      <h6 class="custom-select-title">Minutos:</h6>
                      <select
                        v-model="slot_config[2].duration"
                        class="custom-select"
                      >
                        <option
                          v-for="duration in durations"
                          :key="duration"
                          :selected="duration === slot_config[2].duration"
                          :value="duration"
                        >
                          {{ duration }}
                        </option>
                      </select>
                    </div>
                    <div class="custom-select-text">
                      <p>
                        Serão {{ slot_config[2].duration }} minutos para cada
                        paciente.
                      </p>
                    </div>
                  </form>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="custom-form-control" md="4">
                  <label>Horário:</label>
                  <input
                    :class="{
                      'form-control-invalid':
                        $v.slot_config.$each[2].work_days.$each[0].times
                          .$each[0].start_time.$error
                    }"
                    v-model="
                      $v.slot_config.$each[2].work_days.$each[0].times.$each[0]
                        .start_time.$model
                    "
                    class="form-control input-width"
                    type="time"
                    min="00:00"
                    max="23:59"
                  />
                  <div
                    v-if="
                      $v.slot_config.$each[2].work_days.$each[0].times.$each[0]
                        .start_time.$error
                    "
                  >
                    <p
                      class="error"
                      v-if="
                        !$v.slot_config.$each[2].work_days.$each[0].times
                          .$each[0].start_time.required
                      "
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <button
          @click.prevent="
            $v.$invalid ? $v.$touch() : showConfirmationSlotsModal()
          "
        >
          Salvar
        </button>
      </div>
    </form>

    <BModal
      id="createNewSlots"
      ref="createNewSlots"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Os novos horários foram criados
        </h4>
        <BButton class="button2 mb-2" block @click="$router.push('/')">
          Ir para dashboard
        </BButton>
      </div>
    </BModal>

    <BModal
      id="confirmationModal"
      ref="confirmationModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          {{ `Tem certeza de que ${alertMessage}` }}
        </h4>
        <BButton class="button2 mb-2" block @click="saveSlots()">
          Confirmar
        </BButton>

        <BButton
          class="button2 mb-2"
          block
          @click="hideConfirmationSlotsModal()"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { slotMethods } from "./../state/helpers";

export default {
  name: "ScheduleSettings",
  data() {
    return {
      alertMessage: "quer salvar estes horários?",
      isLoadingSlots: false,
      durations: [15, 30, 45, 60, 90],
      slot_config: [
        {
          from_date: "",
          duration: 15,
          work_days: [
            {
              hours: [],
              times: [{ start_time: "" }]
            }
          ]
        },
        {
          from_date: "",
          duration: 15,
          work_days: [
            {
              hours: [],
              times: [{ start_time: "" }]
            }
          ]
        },
        {
          from_date: "",
          duration: 15,
          work_days: [
            {
              hours: [],
              times: [{ start_time: "" }]
            }
          ]
        }
      ],
      hours: Array.from({ length: 24 }, (v, k) => {
        const h = k.toString();
        return h.length === 2 ? `${h}:00` : `0${h}:00`;
      }),
      work_days: []
    };
  },

  validations: {
    slot_config: {
      $each: {
        from_date: { required },
        work_days: {
          $each: {
            times: {
              $each: {
                start_time: { required }
              }
            }
          }
        }
      }
    }
  },

  methods: {
    ...slotMethods,

    hideConfirmationSlotsModal() {
      this.$bvModal.hide("confirmationModal");
    },

    showConfirmationSlotsModal() {
      this.$bvModal.show("confirmationModal");
    },

    showSaveSlotsModal() {
      this.$bvModal.show("createNewSlots");
    },

    saveSlots() {
      this.$v.$touch();

      let slot_config = [
        {
          from_date: this.slot_config[0].from_date,
          duration: this.slot_config[0].duration,
          work_days: [
            {
              times: [
                {
                  start_time: this.slot_config[0].work_days[0].times[0]
                    .start_time
                }
              ]
            }
          ]
        },
        {
          from_date: this.slot_config[1].from_date,
          duration: this.slot_config[1].duration,
          work_days: [
            {
              times: [
                {
                  start_time: this.slot_config[1].work_days[0].times[0]
                    .start_time
                }
              ]
            }
          ]
        },
        {
          from_date: this.slot_config[2].from_date,
          duration: this.slot_config[2].duration,
          work_days: [
            {
              times: [
                {
                  start_time: this.slot_config[2].work_days[0].times[0]
                    .start_time
                }
              ]
            }
          ]
        }
      ];

      if (!this.$v.$invalid) {
        this.$store
          .dispatch("slot/simpleCreate", slot_config)
          .then(response => response.data);
        this.showSaveSlotsModal();
      }
    }
  }
};
</script>

<style>
@import url(../views/ScheduleSettings/styles.css);
.time-size {
  font-size: 30px;
  padding-bottom: 0px;
}

.form-title {
  margin-bottom: 20px;
  text-align: center;
}
</style>
